import * as React from 'react'
import * as Styled from './styled'
import { RegistrationMessageData } from '../../../lib/registration'

interface RegistrationUserActionRequiredProps {
  message: RegistrationMessageData
}
export const RegistrationUserActionRequired: React.FC<RegistrationUserActionRequiredProps> = ({
  message,
}) => {
  return (
    <Styled.Container>
      <Styled.Title>Almost there!</Styled.Title>
      <Styled.Message>{message.details}</Styled.Message>
    </Styled.Container>
  )
}
